import {Tooltip} from 'platform/components';
import {Text, ThemeTextColorPath} from 'platform/foundation-tw';
import {useDateTimeFormatter} from 'platform/locale';

import {parseDate} from 'shared/web';

import {CellRendererProps} from '../../types/CellRendererProps';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getCellClassName} from '../../utils/getCellClassName';
import {getStylesToRender} from '../../utils/getStylesToRender';
import {getTooltipProps} from '../../utils/getTooltipProps';

type DateCellRendererProps = CellRendererProps<string | null> & {
  getTooltipProps?: TooltipGetter;
};

type CellStyle = {textColor?: ThemeTextColorPath};

export function DateCellRenderer(props: DateCellRendererProps) {
  const className = getCellClassName(props.column);
  const cellStyles = getStylesToRender(props) as CellStyle | undefined;
  const formatDateTime = useDateTimeFormatter();
  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);

  if (!props.value) {
    return null;
  }

  const parsed = parseDate(props.value);

  if (isNaN(parsed.getTime())) {
    return null;
  }

  return (
    <Tooltip {...tooltipProps} label={formatDateTime('dateTimeLong', parsed)}>
      <div className={className}>
        <Text
          color={cellStyles?.textColor}
          noWrap={!props.column?.wrapText}
          size="small"
          overflowWrap={props.column?.wrapText ? 'anywhere' : undefined}
        >
          {formatDateTime('dateShort', parsed)}
        </Text>
      </div>
    </Tooltip>
  );
}
